import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  register(properties: Record<string, any>): void {
    posthog.register(properties);
  }

  capture(eventName: string, properties?: Record<string, any>): void {
    posthog.capture(eventName, properties);
  }

  getDistinctId(): string | undefined {
    return posthog.get_distinct_id();
  }
}
